import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast_config } from "../../utils/constants";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const CreateEvent = createAsyncThunk(
  "CreateEvent",
  async (updatedData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/Event/Create-Event`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Details added successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to add Details",
        toast_config
      );
      return rejectWithValue(error);
    }
  }
);

export const AddEventVendors = createAsyncThunk(
  "AddEventVendors",
  async ({ ID, selectedVendorsData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/api/v1/Event/AddEvent-Vendors/${ID}`,
        { selectedVendorsData },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Vendors added successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to add Details",
        toast_config
      );
      return rejectWithValue(error);
    }
  }
);

export const ShowAllEvents = createAsyncThunk(
  "ShowAllEvents",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/Event/show-AllEvents`
      );
      console.log("res------->", response);
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

// only co-ordinator

export const ShowEvents = createAsyncThunk(
  "ShowEvents",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/Event/show-Events/${ID}`
      );
      console.log("res------->", response);
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowUserEvents = createAsyncThunk(
  "ShowUserEvents",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/Event/show-user-Events/${ID}`
      );
      console.log("res------->", response);
      return response.data;
    } catch (error) {
      // toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

//suport
export const AddSupportMsg = createAsyncThunk(
  "AddSupportMsg",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/Add-Support-Msg`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Send  successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed ", toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowSupportMsg = createAsyncThunk(
  "ShowSupportMsg",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/User/All-Support-Form`
      );
      console.log("res------->", response);
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const deleteSupportMsg = createAsyncThunk(
  "deleteSupportMsg",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/v1/User/Delete-Support-Msg/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Delete successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to Delete ",
        toast_config
      );
      return rejectWithValue(error);
    }
  }
);

export const UpdEventCoordinator = createAsyncThunk(
  "UpdEventCoordinator",
  async ({ ID, CoordinatorID, PreviousCoordinatorID }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/api/v1/Event/Update-Event-Co-ordinator/${ID}`,
        { CoordinatorID, PreviousCoordinatorID },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Update successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to Update",
        toast_config
      );
      return rejectWithValue(error);
    }
  }
);

export const UpdEvent = createAsyncThunk(
  "UpdEvent",
  async ({ id, updatedEventData }, { rejectWithValue }) => {
    console.log(updatedEventData);
    try {
      const response = await axios.put(
        `${BASE_URL}/api/v1/Event/Update-Event/${id}`,
        updatedEventData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Update successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to Update",
        toast_config
      );
      return rejectWithValue(error);
    }
  }
);

// vendor only
export const AddVendorEvent = createAsyncThunk(
  "AddVendorEvent",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/Event/Add-Vendor-Event`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Send  successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed ", toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowVendorEvent = createAsyncThunk(
  "ShowVendorEvent",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/Event/Show-Vendor-Event/${ID}`
      );
      console.log("res------->", response);
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

const EventManagementSlice = createSlice({
  name: "EventManagementSlice",
  initialState: {
    Data: [],
    IsAdding: false,
    loading: false,
    error: null,
  },
  reducers: {
    IsAddingOpen: (state, action) => {
      state.IsAdding = true;
    },
    IsAddingClose: (state, action) => {
      state.IsAdding = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateEvent.pending, (state) => {
        state.loading = true;
      })
      .addCase(CreateEvent.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(AddVendorEvent.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddVendorEvent.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(UpdEvent.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdEvent.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(AddSupportMsg.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddSupportMsg.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(AddEventVendors.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddEventVendors.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(UpdEventCoordinator.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdEventCoordinator.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(ShowAllEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowAllEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = action.payload.events;
      })

      .addCase(ShowEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = action.payload.events;
      })

      .addCase(ShowUserEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowUserEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = action.payload.events;
      })

      .addCase(ShowSupportMsg.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowSupportMsg.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = action.payload;
      })

      .addCase(deleteSupportMsg.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSupportMsg.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(ShowVendorEvent.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowVendorEvent.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = action.payload;
      })

      .addMatcher(
        (action) =>
          action.type.endsWith("/rejected") && action.meta.rejectedWithValue,
        (state, action) => {
          state.loading = false;
          state.error = action.payload.message;
        }
      );
  },
});

export const { IsAddingOpen } = EventManagementSlice.actions;
export default EventManagementSlice.reducer;
